declare let jQuery: any;
import React, { useRef, type ReactElement, type MouseEvent } from 'react';
import { getConfig, getTranslation } from '../../utils/config';

export default function CardLoginRequired({
  handleClose,
}: {
  handleClose: () => void;
}): ReactElement {
  const openModal = useRef(null);
  const handleClick = (e: MouseEvent) => {
    e.preventDefault();
    if ('jQuery' in window) {
      jQuery(openModal.current).magnificPopup({
        type: 'inline',
        closeBtnInside: false,
        callbacks: {
          afterClose: () => {
            document.querySelector('.dropdown-mybeckhoff.mfp-hide')?.classList.remove('mfp-hide');
          },
        },
        allowHTMLInStatusIndicator: true,
        allowHTMLInTemplate: true,
      });
      jQuery(openModal.current).magnificPopup('open');
    }
  };

  return (
    <div className="df-login-info">
      <div className="df-login-info__layer">
        <strong className="df-login-info__headline">{getTranslation('login_title')}</strong>
        <div className="df-login-info__content">
          <p>{getTranslation('login_text')}</p>
        </div>
        <div className="df-login-info__buttons">
          <a
            href={getConfig('registerPage')}
            className="df-btn df-btn--simple df-login-info__register"
          >
            {getTranslation('login_register')}
            <span className="df-btn__icon-right df-icon-arrow_long_right_red" />
          </a>

          <a
            className="df-btn df-login-info__login df-trigger-login-popup"
            href=".dropdown-mybeckhoff"
            onClick={handleClick}
            ref={openModal}
          >
            {getTranslation('login_signin')}&nbsp;
            <span className="df-btn__icon-right df-icon-arrow_long_right_white" />
          </a>
        </div>
        <button
          type="button"
          className="df-btn-special__close"
          onClick={handleClose}
          aria-label={getTranslation('login_close')}
        ></button>
      </div>
    </div>
  );
}
